export type FetchErrorKind = 'http' | 'network' | 'timeout' | 'invalid-response';

type FetchErrorOptions = {
  kind?: FetchErrorKind;
  cause?: unknown;
};

export class FetchError extends Error {
  readonly kind: FetchErrorKind;

  constructor(
    readonly status: number | null,
    readonly url: string,
    readonly body?: unknown,
    options: FetchErrorOptions = {},
  ) {
    const kind = options.kind ?? (status === null ? 'network' : 'http');
    const reason = kind === 'http' ? `HTTP ${status}` : kind;
    super(`Request failed (${reason}): ${url}`, { cause: options.cause });
    this.name = 'FetchError';
    this.kind = kind;
  }

  get isNotFound() {
    return this.status === 404;
  }

  get isNetworkError() {
    return this.kind === 'network';
  }

  get isTimeout() {
    return this.kind === 'timeout';
  }
}

export const isNotFoundError = (error: unknown): error is FetchError => error instanceof FetchError && error.isNotFound;
